/* The left-hand menu inside one salon.
 *
 * Sections come from what has registered — see nav.js — so this file lists
 * nothing and adding a page never touches it. What it does own is the header
 * above the menu, which is the only place on a settings screen that says which
 * business is being edited. That is not decoration: every page below it is a
 * form full of somebody else's configuration, and an app that lets you forget
 * whose is an app that will eventually rename the wrong salon.
 *
 * Hence the suspended banner living here rather than on the Danger zone page
 * that sets it. A frozen salon must be visible from whichever page you happen to
 * be standing on, because it explains every odd thing the customer is reporting.
 */
import { nav } from '../nav.js';
import { store } from '../store.js';

export const Sidebar = {
  name: 'AdminSidebar',
  setup: function () {
    return {
      groups: nav.groups,
      route: nav.route,
      goList: nav.goList,
      goPage: nav.goPage,
      selected: store.selected,
      tenantId: nav.route
    };
  },
  template: [
    '<aside class="side">',
    '  <button type="button" class="side__back" @click="goList()">',
    '    <span aria-hidden="true">&larr;</span> All tenants</button>',
    '',
    '  <div class="side__tenant">',
    '    <h2 class="side__name">{{ selected ? selected.name : "Loading…" }}</h2>',
    '    <p class="side__id" :title="route.tenantId">{{ route.tenantId }}</p>',
    '    <p v-if="selected && selected.suspended_at" class="side__suspended">',
    '      Suspended &mdash; this salon reads and writes nothing.</p>',
    '  </div>',
    '',
    '  <nav class="side__nav">',
    '    <div v-for="g in groups" :key="g.name" class="side__group">',
    '      <h3 class="side__heading">{{ g.name }}</h3>',
    '      <button v-for="p in g.items" :key="p.id" type="button" class="side__item"',
    '        :class="{ \'is-on\': route.pageId === p.id, \'is-danger\': p.danger }"',
    '        @click="goPage(p.id)">',
    '        <span class="side__item-name">{{ p.name }}</span>',
    '      </button>',
    '    </div>',
    '  </nav>',
    '</aside>'
  ].join('\n')
};
